import { IContainer } from "./types"
import css from './index.module.scss'


/** Контейнер */
export const Container = ({ 
    className, type = 'primary', background, 
    padding = '8px', borderRadius = '6px', 
    overflow, children, gap = '6px'
}: IContainer) => {

    /** Изменяемые стили компоненты */
    const componentStyles: React.CSSProperties & { '--container-border-radius': string } = type === 'secondary' ? {
        '--container-border-radius': `calc(var(--border_radius_default) + ${borderRadius})`,
        padding: padding,
        borderRadius: `calc(var(--border_radius_default) + ${borderRadius})`,
        overflow: overflow,
        gap: gap,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    } : {
        '--container-border-radius': `calc(var(--border_radius_default) + ${borderRadius})`,
        padding: padding,
        background: background ? background : 'var(--background_nav_panel)',
        borderRadius: `calc(var(--border_radius_default) + ${borderRadius})`,
        overflow: overflow,
    }

    const isSecondary = type === 'secondary'

    return <>
        <div className={`${css['container']} ${isSecondary ? 'card_style' : ''} ${className || ''}`.trim()} style={componentStyles}>
            {children}
        </div>
    </>
}